import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";

import { 
  collection, 
  query, 
  where, 
  getDocs,
  addDoc,
  deleteDoc,
  doc
} from "firebase/firestore";

import firebase from "../../../firebase";
const db = firebase.firestore;

const firestoreAdapter = createEntityAdapter();

const initialState = firestoreAdapter.getInitialState({
  collection: [],
  status: 'idle',
  error: null
});

// Thunk functions for get a document to a collection
export const getDocument = createAsyncThunk(
  "firestore/getDocument",
  async ({ collectionName, id = null }) => {
    try {
      const snapShot = await db.collection(collectionName).doc(id).get();

      return {...snapShot.data(), id:snapShot.id};
    } catch (error) {
      return {error, status:"failed"};
    }
  }
);

// Thunk functions for get all documents to a collection
export const getCollection = createAsyncThunk(
  "firestore/getCollection",
  async ({ collectionName, whereCondicion = null }) => {
    // data to return from database
    var data = [];

    try {
      // evaluate params for queries to database
      var whereFuncion = null;

      if (whereCondicion !== null){
        var iterator = whereCondicion.values();
        whereFuncion = where(iterator.next().value, iterator.next().value, iterator.next().value);
      }

      const q = query(collection(db, collectionName), whereFuncion);

      const querySnapshot = await getDocs(q);
      await querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        data.push({ ...doc.data(), id: doc.id });
      });

      return {data};

    } catch (error) {
      return {error, status:"failed"};
    }
  }
);

// Thunk functions for add a document to a collection
export const setDocument = createAsyncThunk(
  "firestore/setDocument",
  async ({ collectionName, state }) => {
    try {
      const docRef = await addDoc(collection(db, collectionName), state);

      return (docRef);
    } catch (error) {
      return {error, status:"failed"};
    }
  }
);

// Thunk functions for delete a document to a collection
export const deleteDocument = createAsyncThunk(
  "firestore/deleteDocument",
  async ({ collectionName, id }) => {
    try {
      await deleteDoc(doc(db, collectionName, id));

      return (true);
    } catch (error) {
      return {error, status:"failed"};
    }
  }
);

const firestoreSlice = createSlice({
  name: "firestore",
  initialState,
  reducers: {
    // reducer for get documnets of a collection in real time
    getCollectionRealTime: {
      reducer(state, action) {
        state.collection = [];
        setTimeout(() => {
          console.log("entro 1");
          state.collection.concat(action.payload.docs);
        }, 10);
      },
      prepare(docs) {
        return {
          payload: { docs },
        }
      },
    },
  },
  extraReducers: builder => {
    builder
    // control de estado de la promesa para getCollection
    .addCase(getCollection.pending, (state, action) => {
      state.status = 'loading'
    })
    .addCase(getCollection.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.collection = action.payload
    })
    .addCase(getCollection.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    })
    // control de estado de la promesa para setDocument
    .addCase(setDocument.pending, (state, action) => {
      state.status = 'loading'
    })
    .addCase(setDocument.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.collection = action.payload
    })
    .addCase(setDocument.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    })
    // control de estado de la promesa para deleteDocument
    .addCase(deleteDocument.pending, (state, action) => {
      state.status = 'loading'
    })
    .addCase(deleteDocument.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.collection = action.payload
    })
    .addCase(deleteDocument.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    })
  }
});

export const { getCollectionRealTime } = firestoreSlice.actions;

export default firestoreSlice.reducer;
